module.exports = __webpack_public_path__ + "static/img/Q02K.5256e5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/Q02K.jpg
// module id = gWxq
// module chunks = 0